<template>
  <div class="client">
    <div class="preloader" v-if="preloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <p class="title">{{clientInfo.client.name}}</p>
    <div class="options-block">
      <p><span>Коллекция: </span>{{ clientInfo.collectionTitle }}</p>
      <p><span>Дата отстройки: </span>{{ clientInfo.datePresentation }}</p>

      <button class="sendReport" @click="sendReport()">Отправить отчет</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["clientInfo"],
  data: function () {
    return {
      preloader: false,
    };
  },
  methods: {
    sendReport() {
      this.preloader = true;
      this.$store
        .dispatch("MANUFACTURE_SEND_REPORT", this.clientInfo.id)
        .then((response) => {
            console.log(response)
          setTimeout((e) => {
            this.preloader = false;
            if (response.data.status == "success") {
              this.$makeToast(
                "Отлично!",
                "success",
                "Отчет отправлен на вашу почту!",
                5000
              );
            } else {
              this.$makeToast(
                "Упс!",
                "danger",
                "Не удалось отправить отчет!",
                5000
              );
            }
          }, 500);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.client {
  width: 100%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  .title {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 15px;
  }
  .button {
    width: 100%;
    background: #333333;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000000;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    color: #fff;
  }
  .sendReport {
    width: 100%;
    background: #279b37;
    border: none;
    height: 50px;
    margin-top: 15px;
    text-transform: uppercase;
    color: #fff;
  }
  .options-block {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    p,
    span {
      font-weight: 500;
      font-size: 14px;
      text-transform: capitalize;
      color: #000000;
    }
  }
}
</style>